import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { useTranslation } from 'react-i18next';
import { LayoutBuilder } from '../components/Layouts';
import { ErrorContent } from '../components/Partials/ErrorContent';

type ErrorPageProps = {
  pageConfig: GenericObject;
  code?: string;
  message?: string;
  subtitle?: string;
  btnLabel?: string;
};

const ErrorPage: FC<ErrorPageProps> = ({ pageConfig, code, message, subtitle, btnLabel }) => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{pageConfig.title}</title>
      </Helmet>

      <LayoutBuilder layout={pageConfig.layout}>
        <ErrorContent
          code={code ?? '404'}
          message={message ?? t('errorPage.defaultMessage')}
          subtitle={subtitle ?? t('errorPage.defaultSubtitle')}
          btnLabel={btnLabel ?? t('errorPage.defaultButtonLabel')}
        />
      </LayoutBuilder>
    </>
  );
};

export { ErrorPage };

export default ErrorPage;
